import React, { useEffect } from 'react'
import { Accordion } from 'primereact/accordion'
import { TabPanel } from 'primereact/tabview'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { connect } from 'react-redux'

import {
  CustomModal,
  NumeroDecimal,
  InputNumeroDecimal,
  CustomAccordionTab,
  CustomDataTable,
  CustomTabView,
} from '../../../../../components'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../../store/actions/system.actions'
import useModalDetalhesPorEmpresa, { LOAD_MESSAGE } from './ModalDetalhesPorEmpresaHook'
import { tableCellCentered } from '../../../../../assets/js/styles'

function ModalDetalhesPorEmpresa({ dispatch, show, onModalClose, data, entregas }) {
  const { state, localDispatch } = useModalDetalhesPorEmpresa()

  useEffect(() => {
    if (show) localDispatch.onInit(data, entregas)
  }, [data, entregas, show])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.LOAD_DATA:
        dispatch(showLoadingBox(state.loadingMessage, 'Aguarde...'))
        localDispatch.loadData(state.data, state.entregas)
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  const totaisBlock = (
    <div className="p-grid" style={{ marginTop: 8 }}>
      <div className="p-col-3">
        <InputNumeroDecimal label={`Total Qte. NFs`} value={state.total.nfs} onChange={() => {}} />
      </div>
      <div className="p-col-3">
        <InputNumeroDecimal label={`Total Qte. Volumes`} value={state.total.volumes} onChange={() => {}} />
      </div>
      <div className="p-col-3">
        <InputNumeroDecimal label={`Total Peso`} value={state.total.weight} onChange={() => {}} />
      </div>
      <div className="p-col-3">
        <InputNumeroDecimal label={`Total Qte. SKUs`} value={state.total.sku} onChange={() => {}} />
      </div>
    </div>
  )

  return (
    <CustomModal
      header={`Detalhes Por Empresa`}
      isVisible={show}
      onClose={onModalClose}
      width={800}
    >
      {state.ufLabel && (
        <div style={{ marginBottom: 12, fontWeight: 600 }}>
          Estado: {state.ufLabel}
        </div>
      )}
      <CustomTabView activeIndex={state.activeTabIndex} onTabChange={localDispatch.onTabChange}>
        <TabPanel header="Total">
          <div style={{ overflowY: 'auto', maxHeight: '60vh' }}>
            <DataTable value={state.byCompany} emptyMessage="Sem registros">
              <Column field="company_name" header="Empresa" />
              <Column field="qte_nfs" header="Qte. NFs" style={tableCellCentered(90)} />
              <Column field="qte_volumes" header="Qte. Volumes" style={tableCellCentered(110)} />
              <Column
                field="weightTotal"
                header="Peso Bruto"
                style={tableCellCentered(120)}
                body={i => <NumeroDecimal>{i.weightTotal}</NumeroDecimal>}
              />
              <Column field="qte_sku" header="Qte. SKU´s" style={tableCellCentered(110)} />
            </DataTable>
          </div>
          {totaisBlock}
        </TabPanel>
        <TabPanel header="Cidade">
          <div style={{ overflowY: 'auto', maxHeight: '60vh', marginBottom: 12 }}>
            <Accordion>
              {state.byCity.map(cidade => {
                const header = (
                  <div style={{ display: 'flex',  width: '100%', paddingRight: 8 }}>
                    <span>{cidade.cidadeUf}</span>
                  </div>
                )
                return (
                  <CustomAccordionTab header={header} key={cidade.cidadeUf}>
                    <CustomDataTable value={cidade.empresas} emptyMessage="Sem empresas">
                      <Column field="company_name" header="Empresa" />
                      <Column field="qte_nfs" header="Qte. NFs" style={tableCellCentered(90)} />
                      <Column field="qte_volumes" header="Qte. Volumes" style={tableCellCentered(110)} />
                      <Column
                        field="weightTotal"
                        header="Peso Bruto"
                        style={tableCellCentered(120)}
                        body={i => <NumeroDecimal>{i.weightTotal}</NumeroDecimal>}
                      />
                      <Column field="qte_sku" header="Qte. SKU´s" style={tableCellCentered(110)} />
                    </CustomDataTable>
                    <div className="p-grid" style={{ marginTop: 8 }}>
                      <div className="p-col-3">
                        <InputNumeroDecimal label="Qte. NFs" value={cidade.qte_nfs} onChange={() => {}} />
                      </div>
                      <div className="p-col-3">
                        <InputNumeroDecimal label="Qte. Volumes" value={cidade.qte_volumes} onChange={() => {}} />
                      </div>
                      <div className="p-col-3">
                        <InputNumeroDecimal label="Peso Bruto" value={cidade.weightTotal} onChange={() => {}} />
                      </div>
                      <div className="p-col-3">
                        <InputNumeroDecimal label="Qte. SKUs" value={cidade.qte_sku} onChange={() => {}} />
                      </div>
                    </div>
                  </CustomAccordionTab>
                )
              })}
            </Accordion>
          </div>
          {totaisBlock}
        </TabPanel>
      </CustomTabView>
    </CustomModal>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(ModalDetalhesPorEmpresa)
